import React from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {useSelector} from 'react-redux'
import {GetSchedulerReportId, GetSingleMessageData} from '../reportSlices/reportAnalytics'
import {CircularProgressbar, buildStyles} from 'react-circular-progressbar'
import ReactApexChart from 'react-apexcharts'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {Link, useLocation, useNavigate, useParams} from 'react-router-dom'
import moment from 'moment-timezone'
import {
  useGetSchedulerDetailQuery,
  useGetSchedulerHistoryQuery,
  useGetSchedulerLogQuery,
} from '../../../../../services/cellcast'
import FileSchedulerMessageHistory from './FileSchedulerMessageHistory'
import FileSchedulerMessageLog from './FileSchedulerMessageLog'
import {RoutePaths} from '../../../../routing/RoutePath'

const FileSchedulerDetail = () => {
  const navigate = useNavigate()
  const {id} = useParams()

  const {data: detailSchedule, isLoading: isLoadingDetailSchedule} = useGetSchedulerDetailQuery({
    id,
  })

  return (
    <>
      <div className='row'>
        <div className='col-xl-12 mb-4'>
          <div className='card p-8 py-5'>
            <div className='card-header border-0 p-0 min-h-50'>
              <div className='d-flex flex-col gap-2 align-items-start'>
              <OverlayTrigger
                placement='bottom'
                overlay={<Tooltip id='button-tooltip'>View Detail</Tooltip>}
              >
                <Link
                  to={RoutePaths.reportAnalyticFileSchedulerMessage}
                  className='btn btn-disable btn-sm btn-icon btn-bg-light btn-active-color-primary text-decoration-none'
                >
                  <i className='bi bi-arrow-return-left'></i>
                </Link>
              </OverlayTrigger>
              <h3 className='card-title'>
                <span className='card-label fw-bolder fs-2 mb-1'>Schedule Detail</span>
              </h3>
              </div>
            </div>
            <div className='card-body px-0 pt-1'>
              <div className='analytics_charts bounce_chart'>
                <div className='chart_body'></div>
                <div className='box_container'></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col-xl-4'>
          <div className='card p-8 py-5 h-100'>
            <div
              className='mobile-bg-wrapper grey-bg new_mobile mb-0'
              style={{
                backgroundImage: `url(${toAbsoluteUrl('/media/mobile/NewMobile.png')})`,
              }}
            >
              <div className='mobile-inner'>
                <div className='mobile-head'>
                  <strong className='msg-mobile-title p-6 d-block text-center px-12'>
                    <KTSVG
                      className='svg-icon-8'
                      path='/media/icons/duotune/arrows/mobile_left_arrow.svg'
                    />
                    {detailSchedule?.data?.sender}
                  </strong>
                </div>

                <div className='mobile-body'>
                  <div className='message-box'>
                    <div className='time text-center'>
                      {moment(detailSchedule?.data?.createdAt).format('LT')}
                    </div>
                    <div className='message'>
                      <pre>{detailSchedule?.data?.message}</pre>
                    </div>
                  </div>
                  <div className='send-msg'>
                    <input type='text' />
                    <a
                      href='#'
                      className='send_btn'
                      style={{
                        backgroundImage: `url(${toAbsoluteUrl('/media/mobile/send.svg')})`,
                      }}
                    ></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-xl-8'>
          <div className='card'>
            <FileSchedulerMessageHistory />
          </div>

          <div className='card mt-4'>
            <FileSchedulerMessageLog />
          </div>
        </div>
      </div>
    </>
  )
}

export default FileSchedulerDetail
